export default __webpack_public_path__ + "static/og-image-71dbd90fbb5e7bd26a1acbc8772e076c.png";